import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Observable, throwError, catchError, map } from 'rxjs';
import { User } from '../models';
import { PayerResponse } from '../models/misc/payer-response';
import { AuthService } from '../services';
import { AppState } from '../store/reducers';
import { selectUsersState } from '../store/reducers/users.reducer';
import { Router } from '@angular/router';

export let maintenanceMode = false;

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  appStatusCodes = {
    NO_RESULT: 204,
    RESULT_EXCEEDED: 222,
    NO_CONTENT: 204,
    REQUEST_FAILED: 205,
    BAD_SEARCH: 400,
    DOCUMENT_DELETE_CPS: 400,
    DUPLICATE_CUST_ID: 400,
    FILE_EMPTY: 400,
    INVALID_ORG: 400,
    INVALID_REQUEST: 400,
    TOKEN_EXPIRED: 400,
    MISMATCH_CLIENT_ID: 400,
    PASSWORD_RESET: 400,
    NOTIFICATION: 400,
    PAYER_PORTAL_SERVICE: 500,
    WEB_SERVICE_ERROR: 500,
    PAYER_EXCEPTION_BASE: 500,
    OKTA: 500,
    CONSTRAINT_VIOLATION: 500,
    IDS: 500,
    MAINTENANCE_MODE: 503,
  };

  tkn: string;
  user: User;
  publicPaths: string[] = ['ptk'];



  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth, store: Store<AppState>, private authService: AuthService, private router: Router) {

    store.select(selectUsersState).pipe(takeUntilDestroyed()).subscribe(usersState => {
      this.user = usersState.user;
      this.tkn = usersState.tkn;
      this.publicPaths = usersState.publicPaths;

    });

  }

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let authReq: HttpRequest<any>;

    if (!this.tkn) {
      this.tkn = sessionStorage.getItem('pubtk');
    }

    if (httpRequest.url.indexOf('/portal-rest') !== -1) { // public endpoint
      authReq = httpRequest.clone();
    }
    else { // to AWS gateway services endpoints

      authReq = httpRequest.clone({
        headers: new HttpHeaders()
          .set('PAYER-X-XSRF-TOKEN', this.tkn ? this.tkn : '')
          .set('PAYER-X-ID', this.user ? this.user?.userId.toString(16) : '')
        , withCredentials: true
      });
    }

    const response$ = next.handle(authReq);
    return this.mapReponse(response$);

  }

  mapReponse(response: Observable<HttpEvent<any>>): Observable<HttpEvent<any>> {
    return response.pipe(
      map(event => {
        if (event instanceof HttpResponse && event.body && event.body.responseType) {
          const responseType = event.body.responseType;
          let httpStatusCode: any;
          let code = '---';
          // handle serve response three types: appStatusCode, prpStatusCode or prpStatusCodes
          if (responseType === 'appStatusCode') {
            code = event.body.code;
            httpStatusCode = this.appStatusCodes[code];

            if (httpStatusCode) {
              const newResponse = new HttpResponse({
                headers: event.headers,
                body: event.body.entity as HttpResponse<PayerResponse>, status: httpStatusCode, statusText: code
              });

              if (httpStatusCode < 400) return newResponse; else throw newResponse;

            }

          } else if (responseType === 'prpStatusCode' || responseType === 'prpStatusCodes') {
            throw new HttpErrorResponse({ headers: event.headers, error: event.body, status: 400, statusText: code });
          } else { // error not from app - from infastructure
            throw new HttpErrorResponse({ headers: event.headers, error: event.body, status: 500 });
          }
        }

        return event;
      }),
      catchError(err => {
        if (err.status === 404 || err.status === 403 || err.status === 500) {
          return throwError(() => new HttpErrorResponse({ headers: err.headers, error: err.error, status: 500 }));
        } else if (err.status === 503 && err.error?.code === 'MAINTENANCE_MODE') {

          this.oktaAuth.session.get().then(sessionObject => {
            if (sessionObject.status === 'ACTIVE') {
              maintenanceMode = true;
              this.authService.signOut();
            } else {
              window.location.href = window.location.origin + '/assets/html/maintenance.html';
            }
          });
        } else if (err.status === 401) {
          this.authService.signOut();
        } else {
          return throwError(() => err);
        }
      }));
  }
}
